import {React, useEffect} from 'react'
import { Provider } from 'react-redux'
import { TouchBackend } from 'react-dnd-touch-backend';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import { default as Survey } from './components/editable_survey.jsx'

import store from './store.js'

import { load as loadSurvey }        from '../shared/ducks/survey.js'
import { load as loadCoverageTypes } from '../shared/ducks/coverage_types.js'
import { load as loadInfoFromRails } from './ducks/rails.js'
import { load as loadLookup }        from '../shared/ducks/lookups.js'

const RmgSurveyAdminApp = (props) => {
  useEffect(() => {
        const restoreScroll = () => {
            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';
            document.body.style.position = '';
            document.body.style.height = '';

            const backdrops = document.querySelectorAll('.modal-backdrop, .backdrop, [class*="backdrop"]');
            backdrops.forEach(backdrop => backdrop.remove());
        };

        document.addEventListener('click', restoreScroll);

        // Watch for DOM changes that might lock scroll
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                    if (document.body.style.overflow === 'hidden') {
                        console.log('Detected scroll lock, restoring...');
                        setTimeout(restoreScroll, 100); // Small delay to let other code finish
                    }
                }
            });
        });

        // Watch for style changes on body
        observer.observe(document.body, {
            attributes: true,
            attributeFilter: ['style']
        });
        
        return () => {
            document.removeEventListener('click', restoreScroll);
            observer.disconnect();
        };
    }, []);
    store.dispatch(loadInfoFromRails(props))
    store.dispatch(loadSurvey(props))
    store.dispatch(loadCoverageTypes(props))

    // Store some lookup data referenced by the questions
    store.dispatch(loadLookup('entityTypes',   props.entityTypes))
    store.dispatch(loadLookup('entityTiers',   props.entityTiers))
    store.dispatch(loadLookup('programs',      props.programs))
    store.dispatch(loadLookup('linkToPreview', props.linkToPreview))

    return (
      <DndProvider backend={ HTML5Backend }>
        <Provider store={ store }>
          <Survey />
        </Provider>
      </DndProvider>
    )
}


export default RmgSurveyAdminApp
